/* eslint-disable @typescript-eslint/naming-convention */
import fetchJSON from '@api/api_helper';

import { ApiResponseObject } from '@api/v4/ApiResponseTypes';

/**
 * `source` is required for Uppy uploads: the backend only appends the Filestack API key
 * needed to process external (non-Filestack) URLs when it recognizes an Uppy source.
 * @see Customizable::CustomizeImageableHelpers::UPPY_SOURCES
 */
export interface BrandguideCardImage {
  url: string;
  filename?: string;
  mimetype?: string;
  source?: string;
}

interface UpdateBrandguideProps {
  initialSlug: string;
  cardImage?: BrandguideCardImage;
  isPublic?: boolean;
  name?: string;
  slug?: string;
}

interface Brandguide {
  card_image: string;
  name: string;
  public: boolean;
  slug: string;
}

type BrandguideResponseObject = ApiResponseObject<Brandguide, 'brandguide'>;

// v3 used for PUT because v3 handles triggering BrandguideSlugUpdateJob and v4 does not
const url = (brandguideSlug: string): string => `/api/v3/brandguides/${brandguideSlug}`;

export const updateBrandguide = ({
  cardImage,
  initialSlug,
  isPublic,
  name,
  slug,
}: UpdateBrandguideProps): Promise<BrandguideResponseObject> => (
  fetchJSON(url(initialSlug), {
    method: 'PUT',
    body: {
      brandguides: {
        ...name && { name },
        ...(isPublic !== undefined && { public: isPublic }),
        ...slug && { slug },
        ...cardImage && { options_card_image: cardImage },
      }
    }
  })
    .then((response) => response)
    .catch(async (response) => { throw (await response.json()); })
);
